import { render, staticRenderFns } from "./ChartWidget.vue?vue&type=template&id=1137cc44&scoped=true"
import script from "./ChartWidget.vue?vue&type=script&lang=ts"
export * from "./ChartWidget.vue?vue&type=script&lang=ts"
import style0 from "./ChartWidget.vue?vue&type=style&index=0&id=1137cc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1137cc44",
  null
  
)

export default component.exports